import React, { useEffect, useState,} from 'react';
import { useNavigate} from 'react-router-dom';
import {  Flex, Layout, Menu, message, Space, Badge } from 'antd';
import MainLogout from './MainLogout';
import classes from './cpn.module.css';
import {CloseOutlined} from '@ant-design/icons';
import { useDispatch,useSelector} from 'react-redux'
import { setMain } from '../store/mainSlice'
import { 
    HomeOutlined, 
    FileDoneOutlined, 
    ClusterOutlined,
    BarChartOutlined,
    // InfoCircleOutlined,
    // FileSyncOutlined,
    BankOutlined,
     InboxOutlined,
    // CreditCardOutlined,
    // DollarOutlined,
    // WalletOutlined,
    // DollarCircleOutlined,
} from '@ant-design/icons';
const { Content, Sider } = Layout;
function Main(props) {
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const yh_phone = JSON.parse(localStorage.getItem('jtg-caiwu_yh_phone'))
    const yh_qx = JSON.parse(localStorage.getItem('jtg-caiwu_yh_qx'))
    const reportNum = Number(props.reportRejectedNum?props.reportRejectedNum:0) 
                            + Number(props.reportNeedApproveNum?props.reportNeedApproveNum:0) 
                            + Number(props.reportNeedReadNum?props.reportNeedReadNum:0)
                            + Number(props.reportEndNeedReadNum?props.reportEndNeedReadNum:0)
    const loanNum = Number(props.loanRejectedNum?props.loanRejectedNum:0) 
                            + Number(props.loanNeedApproveNum?props.loanNeedApproveNum:0)
                            + Number(props.loanNeedReadNum?props.loanNeedReadNum:0)
                            + Number(props.loanEndNeedReadNum?props.loanEndNeedReadNum:0)
    const expenseNum = Number(props.expenseRejectedNum?props.expenseRejectedNum:0) 
                            + Number(props.expenseNeedApproveNum?props.expenseNeedApproveNum:0)
                            + Number(props.expenseNeedReadNum?props.expenseNeedReadNum:0)
                            + Number(props.expenseEndNeedReadNum?props.expenseEndNeedReadNum:0)
    const ddzcNum = Number(props.ddzcRejectedNum?props.ddzcRejectedNum:0) 
                            + Number(props.ddzcNeedApproveNum?props.ddzcNeedApproveNum:0)
                            + Number(props.ddzcNeedReadNum?props.ddzcNeedReadNum:0)
                            + Number(props.ddzcEndNeedReadNum?props.ddzcEndNeedReadNum:0)
    const ddsrNum = Number(props.ddsrRejectedNum?props.ddsrRejectedNum:0) 
                            + Number(props.ddsrNeedApproveNum?props.ddsrNeedApproveNum:0)
                            + Number(props.ddsrNeedReadNum?props.ddsrNeedReadNum:0)
                            + Number(props.ddsrEndNeedReadNum?props.ddsrEndNeedReadNum:0)
    const invoiceNum = Number(props.invoiceRejectedNum?props.invoiceRejectedNum:0) 
                            + Number(props.invoiceNeedApproveNum?props.invoiceNeedApproveNum:0)
                            + Number(props.invoiceNeedReadNum?props.invoiceNeedReadNum:0)   
                            + Number(props.invoiceEndNeedReadNum?props.invoiceEndNeedReadNum:0)
    const ducumentNum = reportNum + loanNum + expenseNum + ddzcNum + ddsrNum + invoiceNum;
    const baseMenuItems = [   
        {
            icon: <HomeOutlined />,
            key: '/DeskHome',
            label: '首页', 
            menulabel: '首页',   
        },
        {
            icon: <FileDoneOutlined />,
            key: 'document',
            label:   <span>单据<Badge count={ducumentNum}> <span style={{marginLeft:'10px'}}> 0</span></Badge></span>, 
            menulabel: '单据',  
            theme:'light',
            children:[
                {
                    key: '/ReportList',
                    label: <span>团队报账单<Badge count={reportNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>, 
                    menulabel: '团队报账单',     
                },
                {
                    key: '/IncomeList',
                    label: <span>收款单<Badge count={ddsrNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>, 
                    menulabel: '收款单',   
                },
                {
                    key: '/CostList',
                    label: <span>付款单<Badge count={ddzcNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>, 
                    menulabel: '付款单',   
                },
                {
                    key: '/ExpenseList',
                    label: <span>费用单<Badge count={expenseNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>, 
                    menulabel: '费用单',   
                },
                {
                    key: '/LoanList',
                    label: <span>借款单<Badge count={loanNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>, 
                    menulabel: '借款单',   
                },                      
            ]
        },   
               
        {
            key: 'invoice',
            icon: <InboxOutlined />,
            label: <span>发票<Badge count={invoiceNum}> <span style={{marginLeft:'10px'}}> 1</span></Badge></span>,
            theme:'light',  
            children: [
                {
                    key: '/InvoiceList',
                    label: <span>开票申请<Badge count={invoiceNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,                
                    menulabel: '开票申请',                
                },  
                {
                    key: '/CostInvoiceList',
                    label: '成本票登记',                
                    menulabel: '成本票登记',                
                },  
                {
                    key: '/ExpenseInvoiceList',
                    label: '费用票登记',                
                    menulabel: '费用票登记',                
                },  
            ]
        },    
        // {
        //     key: '/ArapList',
        //     icon: <FileSyncOutlined />,
        //     label: '往来',
        //     theme:'light',       
        // },    
        {
            key: '/BankList',
            icon: <BankOutlined />,
            label: '银行',        
        },      
        {
            key: 'Statistic',
            icon: <BarChartOutlined />,
            label: '报表',
            menulabel: '报表',
            theme:'light',  
            children: [
                {
                    key: '/StatisticProfit',
                    label: '利润',
                    menulabel: '利润报表',
                },
                {
                    key: '/StatisticArap',
                    label: '往来',
                    menulabel: '往来报表',
                },
            ]
        },      
        {
            icon: <ClusterOutlined />,
            key: 'setting',
            label: '设置', 
            menulabel: '设置',   
            theme:'light',
            children:[
                {
                    key: '/ClientList',
                    label: '客户', 
                    menulabel: '客户',   
                },
                {
                    key: '/ClientTypeList',
                    label: '客户类型', 
                    menulabel: '客户类型',  
                    disabled: !yh_qx.includes('管理'),
                },
                {
                    key: '/DeptList',
                    label: '部门', 
                    menulabel: '部门',   
                    disabled: !yh_qx.includes('管理'),
                },
                {
                    key: '/UserList',
                    label: '操作员', 
                    menulabel: '操作员',   
                    disabled: !yh_qx.includes('管理'),
                },
                {
                    key: '/AccountList',
                    label: '银行账户', 
                    menulabel: '银行账户',   
                    disabled: !yh_qx.includes('管理'),
                }, 
                {
                    key: '/InvoiceTypeList',
                    label: '发票类型', 
                    menulabel: '发票类型',   
                    disabled: !yh_qx.includes('管理'),
                }, 
                // {
                //     key: 'node',
                //     label: '审批点', 
                //     menulabel: '审批点',
                //     disabled: !yh_qx.includes('管理'),
                //     theme:'light',
                //     children: [                                    
                //         {
                //             key: '/ReportNodeUpdate',
                //             label: '团队报账单', 
                //             menulabel: '团队报账单审批点',   
                //         },
                //         {
                //             key: '/IncomeNodeList',
                //             label: '收款单', 
                //             menulabel: '收款单审批点',   
                //         },
                //         {
                //             key: '/CostNodeList',
                //             label: '付款单', 
                //             menulabel: '付款单审批点',   
                //         },
                //         {
                //             key: '/ExpenseNodeList',
                //             label: '费用单', 
                //             menulabel: '费用单审批点',   
                //         },
                //         {
                //             key: '/LoanNodeList',
                //             label: '借款单', 
                //             menulabel: '借款单审批点',   
                //         },
                //         {
                //             key: '/InvoiceNodeList',
                //             label: '开票申请', 
                //             menulabel: '开票申请审批点',   
                //         },
                //     ]
                // },            
                {
                    key: '/RuleList',
                    label: '审批规则',
                    menulabel: '审批规则',
                    disabled: !yh_qx.includes('管理'),
                },
                {
                    key: '/UserPassword',
                    label: '修改密码',                
                    menulabel: '修改密码',                
                },          
            ]
        },   
        
        // {
        //     key: 'help',
        //     icon: <InfoCircleOutlined />,
        //     label: '帮助',
        //     theme:'light',
        //     children: [
            
        //         {
        //             key: '/SysCourse',
        //             label: '视频教程',
        //             menulabel: '视频教程',
        //         },     
        //         {
        //             key: '/SysAbout',
        //             label: '关于',
        //             menulabel: '关于',
        //         },                   
                                
        //     ],
        // },    
    ];
    const dispatch = useDispatch();
    const navi = useNavigate();      
    const [collapsed, setCollapsed] = useState(false);
    const mainTags = useSelector(state => state.main.mainTags);     
    const mainTagActive = useSelector(state => state.main.mainTagActive);     

    const onClick = ({key, domEvent}) => {
        if(key==='/UserAdd' && !yh_qx.includes('3')){
            message.error('您没有新增用户的权限！')
            return false
        }
        navi(key);
        
        // 在菜单配置中查找被点击的项
        const findItem = (items, targetKey) => {
            for (const item of items) {
                if (item.key === targetKey) return item;
                if (item.children) {
                    const found = findItem(item.children, targetKey);
                    if (found) return found;
                }
            }
            return null;
        };
        
        const clickedItem = findItem(baseMenuItems, key);
        
        if (clickedItem) {
            const newMainTag = [...mainTags, { 
                key, 
                label: clickedItem.menulabel || clickedItem.label 
            }];
            
            if (mainTags.filter(abc => abc.key === key).length < 1) {            
                dispatch(setMain({mainTags: newMainTag, mainTagActive: key}));
            } else {
                dispatch(setMain({mainTags, mainTagActive: key}));
            }
        }
    };
   
    
    useEffect(() => {
        if(!mainTags){
             dispatch(setMain({mainTags:[{ key:'/DeskHome', label:'首页' }], mainTagActive:'/'}))
        }
        if(mainTagActive){
            navi(mainTagActive)
        }else{
            navi('/')
        }
    },[dispatch, mainTagActive, mainTags, navi])
    // console.log(mainTags);
    return (
        <Layout  style={{ minHeight: '100vh' }}>
             <Sider collapsible collapsed={collapsed} onCollapse={value => setCollapsed(value)} width={138}>
                <div style={{textAlign:'center',padding:"10px",color:"#fff",fontSize:"16px"}}>{qy_name}</div>
                <Menu 
                    theme="dark" 
                    selectedKeys={props.selectedKeys} 
                    mode="vertical"  
                    items={baseMenuItems}  
                    onClick={onClick} 
                />
            </Sider>
            <Layout>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignContent: 'center',
                        paddingRight:"30px",
                        paddingTop:"6px",
                        paddingBottom:"6px",
                        backgroundColor:'#fff'
                    }}
                >
                    {qy_name ?<MainLogout yh_name={yh_name} qy_name={qy_name} yh_phone={yh_phone} yh_qx={yh_qx}/>:<a onClick={() => {navi('/WebLogin')}}>登录</a>}                
                </div> 
                <Layout>                
                    <Layout>  
                        <Flex style={{backgroundColor:"#fff",paddingLeft:"8px"}} wrap>
                            {mainTags && mainTags.map((item,index) => (
                                <Space 
                                    key={item.key}
                                    size={10}
                                    className={classes.mainTag}
                                    style={item.key === mainTagActive? {backgroundColor:"#1890ff",color:"#fff"} : {backgroundColor:"#fff"}}
                                >
                                    
                                    <a 
                                        style={item.key === mainTagActive? {color:"#fff"} : {color:"#000"}}
                                        onClick={() => {
                                            // console.log(item.key);
                                            dispatch(setMain({mainTags:mainTags, mainTagActive:item.key}))
                                            navi(item.key)
                                            // localStorage.setItem('jtg-caiwu_mainTagActive',JSON.stringify(item.key))
                                        }}
                                    >{item.label}</a>
                                    {(item.key !=='/' || (item.key === '/' && index !== 0)) && <CloseOutlined 
                                                            style={{cursor:"pointer"}}
                                                            onClick={() => {
                                                                    const newValue = mainTags.filter(b => b.key !== item.key);
                                                                    if(mainTags.length > 1){
                                                                        const activeKey = mainTags[index - 1].key;
                                                                        dispatch(setMain({mainTags:newValue, mainTagActive:activeKey}))
                                                                        navi(activeKey)
                                                                    }else{
                                                                        dispatch(setMain({mainTags:[{ key:'/DeskHome', label:'首页' }], mainTagActive:'/'}))
                                                                    }
                                                                   

                                                                    // localStorage.setItem('jtg-caiwu_mainTag',JSON.stringify(newValue))
                                                                    // localStorage.setItem('jtg-caiwu_mainTagActive',JSON.stringify(activeKey))
                                                                    
                                                                }}
                                                        />}
                                </Space>
                                
                                ))}
                        </Flex>                 
                        <Content style={{
                            padding:'15px'
                        }}>{props.children}</Content>
                    </Layout>
                </Layout>     
            </Layout>
        </Layout>
    )

}
export default Main